import React from 'react'
import { shortenAddress } from '../../../utils/'
import IToken from '../../../images/token.png'
import { NAME_TOKEN } from '../../../constants'
 import { DownlineType } from '../../../models/affiliate.interface'

interface IProps {
  totalProfit: number
  downlineList: DownlineType[]
}

// "_id":"0x9E0c8e632A13d8Aeeb8d877Fb0e4D1c407B7F6dF"
// ,"benefit":327.175935038}
const ListItems = ( {  downlineList=[],  totalProfit=0 } : IProps ) =>

  {
    return (
      <div className='list-items'>
        <div className='list-items--header'>
          <label>Refer User</label>
          <span>Total Profits: {totalProfit || 0}</span>
        </div>
        <ul className='list-items--content'>
          {downlineList.length ? (
            downlineList.map((item) => {
              return (
                <li className='items' key={`bonus-item-${item.id}`}>
                  <div className='items--title'>
                    <div className='item-left'>
                      <span className={`text-address`}>
                        {shortenAddress(item._id)}
                      </span>
                    </div>
                    <div className='item-right'>
                      <span className={`text-profit active`}>
                        {item.benefit}
                      </span>
                      <div className='icon-token'>
                        <img className='img-token' alt='' src={IToken} />
                        <div className={`text-token active`}>{NAME_TOKEN}</div>
                      </div>
                    </div>
                  </div>
                </li>
              )
            })
          ) : (
            <div className='text-no-refer'>
              <span>No Refer User</span>
            </div>
          )}
        </ul>
      </div>
    )
  }

export default ListItems
